import React, { FC, CSSProperties, useState } from 'react'

import { styled } from '@mui/material/styles'
import { Checkbox, CheckboxProps, FormControlLabel } from '@mui/material'
import { useFormContext } from 'react-hook-form'

const CheckBox = styled(Checkbox)(({ theme }) => ({
  '&.MuiCheckbox-root': {
    color: theme.palette.primary.light,
    opacity: 0.6,
  },
  '&.Mui-checked': {
    color: theme.palette.secondary.main,
    opacity: 1,
  },
  '& ~ .MuiFormControlLabel-label': {
    color: theme.palette.primary.light,
    fontSize: 'inherit',
    opacity: '0.87',
  },
}))

interface ICheckBox extends CheckboxProps {
  checkBoxName: string
  checkBoxLabel: string
  styles?: CSSProperties
  status?: boolean
}

export const GreenCheckBox: FC<ICheckBox> = ({ checkBoxName, checkBoxLabel, styles, status }) => {
  const { register, setValue } = useFormContext()
  const [checked, setChecked] = useState(status || false)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newChecked = event.target.checked
    setChecked(newChecked)
    setValue(checkBoxName, newChecked)
  }

  return (
    <FormControlLabel
      control={<CheckBox {...register(checkBoxName)} onChange={handleChange} />}
      label={checkBoxLabel}
      style={styles}
      checked={checked}
    />
  )
}
